import './DataGridContextMenu.d36666bb6d11c20f88806defd2703876.css';
export default {"contextMenuContainer":"_contextMenuContainer_gjx3n_1"};